// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_na-0";
export var discountCodeInput = "_na-1";